import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import _, {get, find} from 'lodash';
import * as syncActionCreators from '../../../../redux/actionCreators/sync';
import {getSchema as getUserSchema} from '../../../../models/user';
import {getSchema as getProfileSchema} from '../../../../models/applicantProfile';
import { defaultOrdering } from '../../../../lib/dropdowns';
import {Checkbox} from 'material-ui';
import CreateUserModal from './r_CreateUserModal';
import muiThemeable from 'material-ui/styles/muiThemeable';
import TextField from '../../../../common/components/c_TextField';
import MaskedTextField from '../../../../common/components/c_MaskedTextField';
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import SimpleDropDownMenu from '../../../../common/components/SimpleDropDownMenu';
import CheckList from '../../../../common/components/c_CheckList';
import RaisedButton from '../../../../common/components/c_RaisedButton';
import DateInput from '../../../../common/components/DateInput';
import Copyright from '../../../f_copyright/index';
import { updateCountry } from '../../../../lib/users/updates';
import { referralsByRole } from '../../../../lib/staticData';

// import text question response lists
import industryYearsExperienceList from '../../../../common/staticData/industryYearsExperienceList';
import SimpleFileInput from '../../../../common/components/c_SourceSimpleFileInput';
import FlatButton from '../../../../common/components/c_FlatButton';
import shortId from 'shortid';
import QS from 'querystring';
import {getSegmentsPositionsDepartments} from '../../../../common/staticData/SegmentsPositionsDepartments';

const validationObj = {
  user: _.omit(getUserSchema(), 'password'), // password gets validated in the next step
  profile: getProfileSchema()
};

const otherCountryValidation = {
  user : {
    countryOther : {
      required : {
        message : 'This field is required'
      }
    }
  }
};

// this validation is designed to always fail, because when Canada is selected
// as a country, this validation is decorated into the validation stack,
// and it will not equal 12345 -- in other words it will always fail if used
// as a validation -- this is by design.
const canadaCountryValidation = {
  user : {
    country: {
      matches:{
        options: /^12345$/,
        message: 'Please use the link above for Canadian applicants.'
      }
    }
  }
};

const industryTypeOtherValidation = {
  profile : {
    insuranceTypeOther : {
      required : {
        message : 'This field is required'
      }
    }
  }
};

const workedLastInIndustryYesNoValidation = {
  profile : {
    workedLastInIndustryYesNo : {
      required : {
        message : 'This field is required'
      }
    }
  }
};


@connect(store => ({
  user: store.prelimApplication.user,
  profile: store.prelimApplication.profile,
  staticData: store.staticData,
  scrollBarWidth: store.browserData.scrollBarWidth,
  labels: store.labels.PrelimForm,
}))
@muiThemeable()
export default class ApplicationForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    scrollBarWidth: PropTypes.number,
    labels: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    // need to bind functions to self either here or in render
    this.handleUI = ::this.handleUI;
    this.toggleShowCreateUserModal = ::this.toggleShowCreateUserModal;
    this.yearsExperienceList = _.times(35, (i) => i + 1);
  }

  state = {
    showCreateUserModal: false,
    availabilityDateText: '',
    availabilityDate: null,
    showErrorMessage: false,
    lastWorkedInIndustryItems: [],
  }

  componentDidMount = () => {
    // Set Initial list of items (this is so that for non-insurance tenants, we have the whole list)
    this.setState({
      lastWorkedInIndustryItems: this.props.staticData.applicantYearsWorkedLastIndustry.filter(item => !item.hide).map((item) => item.text)
    });
    const firstTimeQueryString = QS.parse((window.location.search).substring(1));
    const { countryList } = this.props.staticData;
    const defaultCountry = countryList.find(c => c.name === 'United States').id || 0;
    this.setState({
      prelimApplication: {
        profile: {
          firstTimeQueryString
        },
        user: {
          country: defaultCountry
        }
      }
      });
    this.props.profile.firstTimeQueryString = firstTimeQueryString;
    this.props.user.country = defaultCountry;
  }

  onChange = (propParent, prop, event, newVal) => {
    // update field
    if (prop === 'optIntoNewsletter') {
      this.props.dispatch(syncActionCreators.updatePrelimForm({
        [propParent]: {
          [prop]: !this.refs.optIntoNewsletter.state.switched
        }
      }));
    } else {
      this.props.dispatch(syncActionCreators.updatePrelimForm({
        [propParent]: {
          [prop]: newVal || event.target.value
        }
      }));
    }
  };


  onCountryChange = (event, value) => {

    const { countryList } = this.props.staticData;
    const updateUserCountry = updateCountry(countryList);
    const user = updateUserCountry(value || event.target.value);

    this.props.dispatch(syncActionCreators.updatePrelimForm({user}));
  }

  onErrorChange = changeInt => {
    this.errorCount = this.errorCount + changeInt;
  };

  // refilter the list of items based on if the insurance applicant has worked in the industry in the last 5 years or not
  onLastWorkedChange = (event, value) => {
    this.setState({
      prelimApplication: {
        profile: {
          workedLastInIndustry: null
        }
      },
      lastWorkedInIndustryItems: value === true
        ? this.props.staticData.applicantYearsWorkedLastIndustry.filter(item => (!item.hide && (item.text === 'Less than 1 year ago' || item.text === '1-5 years ago'))).map((item) => item.text)
        : this.props.staticData.applicantYearsWorkedLastIndustry.filter(item => (!item.hide && item.text !== 'Less than 1 year ago' && item.text !== '1-5 years ago')).map((item) => item.text)
    }, () => {
      this.props.profile.workedLastInIndustry = null;
      this.refs.workedLastInIndustry.validate();
    });

  }

  today = new Date();
  errorCount = 0;

  handleLastWorkedDropDown() {
    const attributes = this.handleUI('workedLastInIndustryYesNo');
    attributes.onChange = this.onLastWorkedChange;
    return attributes;

    // return {onChange: this.onLastWorkedChange};
  }

  // decorate static validation with dynamic validation
  validationSchema() {

    const dynamicValidation = _.merge({}, validationObj); // do *not* merge into validationObj

    const { countryList, industryTypesList, account } = this.props.staticData;
    const { user, profile } = this.props;
    const canadaCountry = countryList.find(c => c.name === 'Canada');
    const otherCountry = countryList.find(c => c.subElement === 'Other');
    const otherIndustryType = get(find(industryTypesList, {subElement: 'Other'}), 'id');

    if (user.country === canadaCountry.id) {
      _.merge(dynamicValidation, canadaCountryValidation);
    }

    if (otherCountry && user.country === otherCountry.id) {
      _.merge(dynamicValidation, otherCountryValidation);
    }
    if (!!get(profile, 'industryTypes', []).includes(otherIndustryType)) {
      _.merge(dynamicValidation, industryTypeOtherValidation);
    }
    if (account.hardcodelink === 'WAHVE') {
      _.merge(dynamicValidation, workedLastInIndustryYesNoValidation);
    }

    return dynamicValidation;
  }

  handleUI(prop, bindOnChange, defaultValue = null, bindOnClick) {
    const propParent = this.props.user.hasOwnProperty(prop) ? 'user' : 'profile';
    const propValidationObj = this.validationSchema()[propParent][prop];
    let changeAction = bindOnChange ? 'onChange' : 'onBlur';
    if (bindOnClick) {
      changeAction = 'onClick';
    }
    return {
      'data-id': prop,
      floatingLabelText: _.get(this.props.labels, prop),
      [changeAction]: this.onChange.bind(this, propParent, prop),
      onErrorChange: this.onErrorChange,
      validation: propValidationObj,
      ref: prop,
      defaultValue: defaultValue === null ? this.props[propParent][prop] : defaultValue,
    };
  }

  handleCountryDropDown(prop, bindOnChange, defaultValue = null) {
    const attributes = this.handleUI(prop, true, defaultValue);
    attributes.onChange = this.onCountryChange;
    return attributes;
  }

  onUploadStart = (err, infoObj) => {
    let inc = 65;
    const getIncrementedChar = () => String.fromCharCode(inc++);
    const clientId = `${getIncrementedChar()}${shortId.generate()}`;
    this.props.dispatch(syncActionCreators.updatePrelimForm({
      profile: {
        resumeClientId: clientId,
        resumeFileName: infoObj.name,
        resumeFileSize: infoObj.size,
        resumeStoragePath: infoObj.nameWithFolder
      }
    }));
  }

  onS3Load = err => {
    // updating UI optimistically so we only need to know if there was an error
    if(err && process.env.NODE_ENV !== 'production') {
      console.error(err);
    }
  }

  toggleShowCreateUserModal() {
    if (!!this.errorCount) {
      // trigger blur event to force validation errors
      for (const refKey in this.refs) {
        if (this.refs[refKey].checkErrors) {
          this.refs[refKey].checkErrors();
        }
      }
      this.setState(state => _.merge({}, state, {
        showErrorMessage: true
      }));
    }
    else {
      this.setState(state => _.merge({}, state, {
        showCreateUserModal: !this.state.showCreateUserModal,
        showErrorMessage: false
      }));
    }
  }

  // styling obj

  renderStateZip(state, props) {
    const {
      stateList = [],
      countryList = []
    } = props.staticData;
    const selectedCountry = get(props, 'user.country');
    const otherCountry = countryList.find(c => c.subElement === 'Other');
    const us = countryList.find(c => c.name === 'United States');

    if (!_.isNil(selectedCountry) && otherCountry && selectedCountry === otherCountry.id) {

      return (
        <TextField
          {...this.handleUI('countryOther')}
          floatingLabelText='Please specify country' />
      );

    }
    else if (!selectedCountry || us && selectedCountry === us.id) {

      return (
        <div className='box-c'>
          <div className='box-i'>
            <SimpleDropDownMenu
              menuItems={_.concat({primaryText: 'Select', value: 0}, stateList)}
              underlineStyle={{margin: '-1px 0px'}}
              iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
              labelStyle={{paddingLeft: '0px'}}
              {...this.handleUI('state', true, 0)}
              floatingLabelText='State' />
          </div>
          <div className='box-i'>
            <MaskedTextField
              hideMaskChar
              mask='99999'
              {...this.handleUI('zip')}
              floatingLabelText='Zip' />
          </div>
        </div>
      );

    }

  }


  render() {
    const {
      user,
      profile,
      scrollBarWidth,
    } = this.props;

    const {
      foundUsViaList,
      employmentStatusList,
      bestContactTimeList,
      timezoneList,
      industryTypesList,
      countryList,
      phoneTypeList,
      applicantWorkFromHomeReasonsList,
      applicantTotalYearsExperience,
    } = this.props.staticData;

    const addButtonStyle = {
      display: 'inline-block',
      top: '11px',
      width: '165px',
      transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
    };

    const foundUsVia = referralsByRole(foundUsViaList);
    const otherIndustryType = get(find(industryTypesList, {subElement: 'Other'}), 'id');
    const otherfoundUsVia = get(find(foundUsViaList, {name: 'Other, Please Specify:'}), 'id');
    const menuItems = _.concat({primaryText: 'Select', value: 0}, foundUsVia.sort(defaultOrdering));
    const {segments, positions, departments} = getSegmentsPositionsDepartments(this.props);
    return (
      <form className='application-form clearfix'>
        <div className='form-section clearfix application-section-container contact-information'>
          <h1 className='form-section-header'>
            Contact Information
          </h1>
          <br></br>
          <div className='box-container-fixed clearfix'>
            <div className='box'>
              <TextField
                {...this.handleUI('firstName')}
                floatingLabelText='First Name' />
            </div>
            <div className='box'>
              <TextField
                optional
                {...this.handleUI('middleName')}
                floatingLabelText='Middle Name or Initial' />
            </div>
            <div className='box'>
              <TextField
                {...this.handleUI('lastName')}
                floatingLabelText='Last Name' />
            </div>
            {
              [null].map((val, index) =>
              <div className={`box ${index > 0 ? 'mobile-hide' : ''}`}>
                <div className='box-c' key={index}>
                  <div className='box-i'>
                    <MaskedTextField
                      hideMaskChar

                      // floatingLabelFixed
                      optional={index > 0}
                      value={user[`phoneNumber${index + 1}`]}
                      mask='(999) 999-9999'
                      {...this.handleUI(`phoneNumber${index + 1}`)}
                      floatingLabelText='Phone Number' />
                  </div>

                  <div className='box-i'>
                    <DropDownMenu
                      menuItems={phoneTypeList}
                      {...this.handleUI(`phoneType${index + 1}`, true, 0)} />
                  </div>
                </div>
              </div>
              )
            }
            <div className='box'>
              <TextField
                {...this.handleUI('email')}
                floatingLabelText='Email' />
            </div>
            <div className='box'>
              <DropDownMenu
                menuItems={countryList}
                value={user.country | countryList.find(c => c.name === 'United States').id}
                {...this.handleCountryDropDown('country', true)}
                floatingLabelText='Country of Residence'
                disabled
              />
            </div>
            <div className='box'>
              <DropDownMenu
                menuItems={bestContactTimeList}
                {...this.handleUI('bestContactTime', true)}
                floatingLabelText='What is the best time to call you?' />
            </div>

            <div className='box'>
            {
              this.renderStateZip(this.state, this.props)
            }
            </div>

            <div className='box'>
              <DropDownMenu
                menuItems={timezoneList}
                {...this.handleUI('timezone', true)}
                floatingLabelText='Time Zone' />
            </div>
          </div>
        </div>

        <div className='preliminary-info form-section clearfix'>
          <h1 className='form-section-header'>
            Preliminary Information
          </h1>
          <div className='box-container-fixed clearfix'>
            <div className='box'>
              <DropDownMenu
                menuItems={employmentStatusList}
                {...this.handleUI('employmentStatus', true)}
                floatingLabelText='Employment status' />
            </div>
            <div className='box'>
              <DateInput
                autoOk
                dateFormat={'Full'}
                floatingLabelFocusStyle={{whiteSpace: 'normal'}}
                floatingLabelFixed
                minDate={this.today}
                textStyle={{margin: ''}}
                isDirty={this.state.showErrorMessage}
                {...this.handleUI('availabilityDate', false)}
                floatingLabelText='When are you available to start?' />
            </div>
            <div className='box'>
              <DropDownMenu
                menuItems={this.yearsExperienceList}
                {...this.handleUI('totalYearsExperienceNumeric')}
                floatingLabelText='Total Years Experience' />
            </div>
            <div className='box'>
              <DropDownMenu
                menuItems={this.yearsExperienceList}
                {...this.handleUI('industryYearsExperienceNumeric')}
                floatingLabelText='Industry Years Experience' />
            </div>
            <div className='box'>
              {
                <DropDownMenu
                  menuItems={['Yes', 'No']}
                  floatingLabelText={get(this.props.labels, 'workedLastInIndustryYesNo')}
                  {...this.handleLastWorkedDropDown('workedLastInIndustryYesNo', true)}/>
              }
            </div>
            <div className='box'>
              <CheckList
                menuItems={industryTypesList}
                scrollBarWidth={scrollBarWidth}
                { ...this.handleUI('industryTypes', true) } />
            </div>
            {
              !!get(profile, 'industryTypes', []).includes(otherIndustryType)
              &&
              <div className='box'>
                <TextField
                  {...this.handleUI('insuranceTypeOther')}
                  floatingLabelText='Please specify' />
              </div>
            }

            {
              this.props.staticData.account.hardcodelink === 'WAHVE' &&
              <div className='box'>
                {
                  <DropDownMenu
                    menuItems={segments}
                    { ...this.handleUI('mostRecentSegment', true) } />
                }
              </div>
            }

            {
              this.props.staticData.account.hardcodelink === 'WAHVE' &&
              <div className='box'>
                {
                  <DropDownMenu
                    menuItems={departments}
                    floatingLabelText='department'
                    { ...this.handleUI('mostRecentDepartment', true) } />
                }
              </div>
            }

            {
              this.props.staticData.account.hardcodelink === 'WAHVE' &&
              <div className='box'>
                {
                  <DropDownMenu
                    menuItems={positions}
                    floatingLabelText='position'
                    { ...this.handleUI('mostRecentPosition', true) } />
                }
              </div>
            }

              <div className='box'>
                <CheckList
                  menuItems={applicantWorkFromHomeReasonsList}
                  scrollBarWidth={scrollBarWidth}
                  {...this.handleUI('workFromHomeReasons', true)}
                  floatingLabelText='Please let us know why you want to work from home. Select as many that apply.' />
              </div>
             {
               !!(profile.workFromHomeReasons && (profile.workFromHomeReasons.includes((applicantWorkFromHomeReasonsList.find(t => t.name === 'Other, Please Specify') || {}).id)))
               &&
              <div className='box'>
                <TextField
                  {...this.handleUI('workFromHomeReasonOther')}
                  floatingLabelText='Please Specify' />
              </div>
             }
            <div className='box'>
              <SimpleDropDownMenu
                canAutoPosition='true'
                menuItems={menuItems}
                pickedSub={Math.random() > 0.5 ? 'Other' : ''}
                underlineStyle={{margin: '-1px 0px'}}
                iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
                labelStyle={{paddingLeft: '0px'}}
                {...this.handleUI('foundUsVia', true, 0)} />
            </div>

            {
              profile.foundUsVia === otherfoundUsVia
              &&
              <div className='box'>
                <TextField
                  {...this.handleUI('foundUsOther')}
                  floatingLabelText='Please Specify' />
              </div>
           }

            <div className='box'>
              {
                <Checkbox
                  label = {get(this.props.labels, 'optIntoNewsletter')}
                  labelStyle = {{fontSize: 14}}
                  {...this.handleUI('optIntoNewsletter', null, null, true)}
                />
              }
            </div>

          </div>
        </div>

        <h1 className='form-section-header'>
          Please Attach Your Resume
        </h1>
        <br></br>
        <div className='documents-container application-section-container clearfix'>
          {
            profile.resumeFileName !== undefined
            &&
              <div style={{color:'red'}}>
                Your Resume is Attached
              </div>
          }

          <SimpleFileInput
            className='file-uploader'
            noMessage
            pristineClass=''
            loadingClass=''
            successClass=''
            failureClass=''
            accept={['pdf', 'doc', 'docx', 'tiff', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png']}
            remoteFolder='applicants'
            onLoadStart={this.onUploadStart}
            onS3Load={this.onS3Load}
            signingRoute='/api/s3/put-sign'
            maxSize={process.env.AWS_FILE_UPLOAD_SIZE}
            accountId={this.props.staticData.account.id}
          >
            <FlatButton
              style={{...addButtonStyle}}
              label='Attach File'
            />
          </SimpleFileInput>

        </div>

        <div className='form-submit-container'>
          <RaisedButton label='Continue'
                        onClick={this.toggleShowCreateUserModal}/>
          {
            this.state.showErrorMessage
            &&
            <div className='error-message'>Please fill out the required fields above.</div>
          }
        </div>

        {
          this.state.showCreateUserModal
          &&
          <CreateUserModal closeFunction={this.toggleShowCreateUserModal}/>
        }
        <Copyright />
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/index.js